import { createAsyncThunk } from "@reduxjs/toolkit"

import { handleApiError } from "../../../Utils/thunkHelpers"
import * as services from "../services"
import { MARKETING_SLICE_NAME } from "./marketing.constants"

export const getMarketingLinks = createAsyncThunk(
  `${MARKETING_SLICE_NAME}/get_marketing_links`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getMarketingLinks(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getSourceData = createAsyncThunk(
  `${MARKETING_SLICE_NAME}/get_source_data`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getSourceData(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getCampaignData = createAsyncThunk(
  `${MARKETING_SLICE_NAME}/get_campaign_data`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getCampaignData(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getTotalUsers = createAsyncThunk(
  `${MARKETING_SLICE_NAME}/get_total_users`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getTotalUsers(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getSource = createAsyncThunk(
  `${MARKETING_SLICE_NAME}/get_source`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getSource(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getCampaign = createAsyncThunk(
  `${MARKETING_SLICE_NAME}/get_campaign`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getCampaign(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const createSource = createAsyncThunk(
  `${MARKETING_SLICE_NAME}/create_source`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.createSource(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    // Legacy saga config carried `extraAction: [getSourceRequest]` — refresh the list
    // (and the `options.source` select) right after a successful create.
    dispatch(getSource())
    return response.data
  }
)

export const createCampaign = createAsyncThunk(
  `${MARKETING_SLICE_NAME}/create_campaign`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.createCampaign(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    // Legacy saga config carried `extraAction: [getCampaignRequest]`.
    dispatch(getCampaign())
    return response.data
  }
)

export const generateLink = createAsyncThunk(
  `${MARKETING_SLICE_NAME}/generate_link`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.generateLink(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)

export const getLinkUsers = createAsyncThunk(
  `${MARKETING_SLICE_NAME}/get_link_users`,
  async (params, { dispatch, rejectWithValue }) => {
    const response = await services.getMarketingLinkUsers(params)
    if (!response.ok) {
      await handleApiError(dispatch, response)
      return rejectWithValue(response.data)
    }
    return response.data
  }
)
